import React from "react";
import Notice from "./Notice";

export default ({ notice, context }) => {
  const postType = context === "designer" ? "work" : "mission";
  return <Notice type="success" optionName={notice + "_" + postType + "_notice"}></Notice>;
};
